// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthWrapper_wrapper__56dnr"};